"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestGetIssuesVisibleAgain = exports.requestGetIssuesVisible = exports.resetGetIssuesVisible = void 0;
const xuder_1 = require("@sonar-software/xuder");
const get_1 = require("./get.js");
const sonar_ts_types_1 = require("@sonar-software/sonar-ts-types");
const getActions = get_1.issuesVisibleGetSlice.asyncActionCreators;
exports.resetGetIssuesVisible = getActions.resetGetIssuesVisible;
_a = (0, xuder_1.createRepeatActions)(getActions.requestGetIssuesVisible, {
    count: 20,
    paginationDirection: sonar_ts_types_1.PaginationDirection.Forward
}), exports.requestGetIssuesVisible = _a.action, exports.requestGetIssuesVisibleAgain = _a.repeatAction;
//# sourceMappingURL=actions.js.map